import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { DEFAULT_FONT_FAMILY_ITALIC, DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
/** Maps each role-change subject to a message explaining why the role change was only partial */
const reasonMessages = {
  group: newRole => `The role could not be fully changed because the member is the ${newRole?.toLocaleLowerCase()} of a group.`,
  team: newRole => `The role could not be fully changed because the member has the ${newRole?.toLocaleLowerCase()} role through a team.`
};

/** Helper function to generate the message about removing the member from the group/team */
function getRemovalMessage(roleSubject) {
  return `please remove the member from the ${roleSubject} first.`;
}
export function RolePartiallyChanged(t0) {
  const $ = _c(14);
  const {
    intendedRole,
    newRole,
    roleSubject
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontSize: DEFAULT_INPUT_FONT_SIZE
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== newRole || $[2] !== roleSubject) {
    t2 = reasonMessages[roleSubject](newRole);
    $[1] = newRole;
    $[2] = roleSubject;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontFamily: DEFAULT_FONT_FAMILY_ITALIC
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== intendedRole) {
    t5 = <Box component="span" sx={t4}>{" "}{intendedRole}{", "}</Box>;
    $[6] = intendedRole;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== roleSubject) {
    t6 = getRemovalMessage(roleSubject);
    $[8] = roleSubject;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Box component="div" sx={t1}>{t2}{t3}To change the role to{t5}{t6}</Box>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}